import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const relatedPages = [
  { href: '/about' },
  { href: '/association' },
  { href: '/philosophy' },
  { href: '/courses' },
  { href: '/curriculum' },
  { href: '/certificate' },
];

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function RelatedPages() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            LEARN MORE
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerSchool.related.title')}
          </h2>
          {renderParagraphs(
            t('butlerSchool.related.subtitleEn'),
            'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4'
          )}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {relatedPages.map((page, idx) => (
            <Link
              key={page.href}
              to={page.href}
              className="card-glow group block bg-background-100/60 border border-background-200/60 p-5 cursor-pointer"
            >
              <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {t(`butlerSchool.related.link${idx}.title`)}
              </h3>
              {renderParagraphs(
                t(`butlerSchool.related.link${idx}.desc`),
                'text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3'
              )}
              <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                <span className="text-[13px] tracking-[0.06em]">
                  {t('butlerSchool.related.viewLink')}
                </span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center pt-8 border-t border-background-200/60">
          <Link
            to="/japan-butler-academy"
            className="text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors"
          >
            {t('butlerSchool.related.backLink')}
          </Link>
        </div>
      </div>
    </section>
  );
}
